import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/home/HomeView.vue'
import store from '@/store'


Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   component: CommonContainer,
  //   children: [{
  //     path: '/',
  //     name: 'home',
  //     component: Home
  //   }]
  // },
  {
    path: '/',
    title: '电子科技大学出版社-数智出版云平台',
    name: 'homeView',
    component: HomeView
  },
  {
    path: '/contact',
    title: "联系我们 - 电子科技大学出版社-数智出版云平台",
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '@/views/contact/ContactView.vue')
  },
  {
    path: '/booklist',
    name: 'booklist',
    component: () => import(/* webpackChunkName: "BookList" */ '@/views/bookList/BookListView.vue')
  },
  {
    path: '/digitalTextbook/detail/:id',
    name: 'textbookDetail',
    meta: { listRoute: 'digitalTextbook', moduleName: '数字教材' },
    component: () => import(/* webpackChunkName: "BookInfo" */ '@/views/bookInfo/BookInfoView.vue')
  },
  {
    path: '/bookinfo/:id',
    name: 'bookinfo',
    meta: { listRoute: 'booklist', moduleName: '电子书' },
    component: () => import(/* webpackChunkName: "BookInfo" */ '@/views/bookInfo/BookInfoView.vue')
  },
  {
    path: '/digitalClassroom/detail/:id',
    name: 'columnClassroomDetail',
    meta: { listRoute: 'digitalClassroom', moduleName: '数字课堂' },
    component: () => import(/* webpackChunkName: "ColumnInfo" */ '@/views/column/ColumnInfoView.vue')
  },
  {
    path: '/digitalResources/detail/:id',
    name: 'columnResourcesDetail',
    meta: { listRoute: 'digitalResources', moduleName: '数字资源' },
    component: () => import(/* webpackChunkName: "ColumnInfo" */ '@/views/column/ColumnInfoView.vue')
  },
  {
    path: '/login',
    title: '登录 - 电子科技大学出版社-数智出版云平台',
    name: 'login',
    component: () => import(/* webpackChunkName: "Login" */ '@/views/login/LoginView.vue')
  },
  {
    path: '/signup',
    title: '注册 - 电子科技大学出版社-数智出版云平台',
    name: 'signup',
    component: () => import(/* webpackChunkName: "Signup" */ '@/views/signup/SignupView.vue')
  },
  {
    path: '/resetPasswd',
    title: '重置密码 - 电子科技大学出版社-数智出版云平台',
    name: 'resetPasswd',
    component: () => import(/* webpackChunkName: "ResetPasswd" */ '@/views/resetPasswd/ResetPasswdView.vue')
  },
  {
    path: '/userspace',
    title: '个人中心 - 电子科技大学出版社-数智出版云平台',
    name: 'userspace',
    requireLogin: true,
    component: () => import(/* webpackChunkName: "UserSpace" */ '@/views/userSpace/UserSpaceView.vue')
  },
  {
    path: '/bookshelf',
    title: '我的书架 - 电子科技大学出版社-数智出版云平台',
    name: 'bookshelf',
    requireLogin: true,
    component: () => import(/* webpackChunkName: "bookshelf" */ '@/views/userSpace/BookshelfView.vue')
  },
  {
    path: '/digitalTextbook',
    name: 'digitalTextbook',
    component: () => import('@/views/digitalTextbook/DigitalTextbookView.vue')
  },
  {
    path: '/digitalClassroom',
    name: 'digitalClassroom',
    component: () => import('@/views/digitalClassroom/DigitalClassroomView.vue')
  },
  {
    path: '/digitalResources',
    name: 'digitalResources',
    component: () => import('@/views/digitalResources/DigitalResourcesView.vue')
  },
  {
    path: '/knowledgeService',
    name: 'knowledgeService',
    component: () => import('@/views/knowledgeService/KnowledgeServiceView.vue')
  },
  {
    path: '/digitalClassroom/player/:id',
    name: 'coursePlayer',
    component: () => import('@/views/digitalClassroom/CoursePlayerView.vue')
  },
  {
    path: '/news',
    title: '资讯信息 - 电子科技大学出版社-数智出版云平台',
    name: 'news',
    component: () => import(/* webpackChunkName: "news" */ '@/views/news/NewsView.vue')
  },
  {
    path: '/news/:id',
    name: 'newsDetail',
    component: () => import(/* webpackChunkName: "newsDetail" */ '@/views/news/NewsDetailView.vue')
  },
  {
    path: '/knowledgeService/detail/:id',
    name: 'knowledgeDetail',
    component: () => import('@/views/knowledgeService/KnowledgeDetailPC.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/search/SearchView.vue')
  },
  {
    path: '/trade/pay/native',
    name: 'tradeNativePay',
    title: '微信扫码支付 - 电子科技大学出版社-数智出版云平台',
    requireLogin: true,
    component: () => import('@/views/trade/NativePayPage.vue')
  },
  {
    path: '/trade/pay/result',
    name: 'tradePayResult',
    title: '支付结果 - 电子科技大学出版社-数智出版云平台',
    requireLogin: true,
    component: () => import('@/views/trade/PayResultPage.vue')
  },
  {
    path: '/learning-data',
    title: '学习数据 - 电子科技大学出版社-数智出版云平台',
    name: 'learningData',
    requireLogin: true,
    component: () => import(/* webpackChunkName: "learningData" */ '@/views/userSpace/LearningDataMobile.vue')
  },
  {
    path: '/orders',
    title: '我的订单 - 电子科技大学出版社-数智出版云平台',
    name: 'orderList',
    requireLogin: true,
    component: () => import(/* webpackChunkName: "orderList" */ '@/views/userSpace/OrderListView.vue')
  }
]

/**
 * 根据 name 在路由表中递归查找对应的 route 配置对象
 * @param {string} name 路由 name
 * @param {Array} routeList 路由数组（默认可传顶层 routes）
 * @returns {Object|undefined} 匹配的 route，未找到则 undefined
 */
function findRouteByName(name, routeList) {
  if (name == null || name === '' || !Array.isArray(routeList)) {
    return undefined
  }
  for (let i = 0; i < routeList.length; i++) {
    const route = routeList[i]
    if (route.name === name) {
      return route
    }
    if (route.children && route.children.length) {
      const found = findRouteByName(name, route.children)
      if (found !== undefined) {
        return found
      }
    }
  }
  return undefined
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const route = findRouteByName(to.name, routes)
  if (route && route.title) {
    document.title = route.title
  }
  if (!route || !route.requireLogin) {
    next()
    return
  }

  let userInfo = store.state.security.userInfo
  if (!userInfo || !userInfo.id) {
    try {
      userInfo = await store.dispatch('security/ensureUserInfo')
    } catch (e) {
      next({ name: 'login' })
      return
    }
  }

  if (!userInfo || !userInfo.id) {
    next({ name: 'login' })
  } else {
    next()
  }
})

export { findRouteByName, routes }

export default router
